export default "__VITE_ASSET__aGWHZDA0__"